import * as Types from '../../../graphql';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetClientFormMicroProfitDataQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  instance: Types.Scalars['String'];
}>;


export type GetClientFormMicroProfitDataQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getClientFormMicroProfitDataUsingGET?: { __typename?: 'accounts_MicroProfitFormRepresentation', data?: { __typename?: 'accounts_MicroProfitDataRepresentation', are1FTE?: boolean | null, areConsultanta80?: boolean | null, are253Micro?: boolean | null, pastreazaFirmaMicro?: boolean | null, ramaneMicro?: boolean | null, doresteMicro?: boolean | null, devineMicro?: boolean | null, ramaneProfit?: boolean | null, devineProfit?: boolean | null, micro1p?: boolean | null, micro3p?: boolean | null, caSub500k?: boolean | null, defaultAre1FTE?: boolean | null, defaultAreConsultanta80?: boolean | null, defaultAre253Micro?: boolean | null } | null, formData?: { __typename?: 'accounts_ClientFormDataRepresentation', companyName?: string | null, display?: string | null, description?: string | null, displayRole?: string | null, status?: string | null, expires?: number | null, parameters?: any | null } | null } | null } | null };

export type UpdateClientFormMicroProfitDataMutationVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  instance: Types.Scalars['String'];
  data: Types.Accounts_MicroProfitAnswersRepresentationInput;
}>;


export type UpdateClientFormMicroProfitDataMutation = { __typename?: 'Mutation', accounts?: { __typename?: 'accounts_mutation', updateClientFormMicroProfitDataUsingPUT?: { __typename?: 'accounts_SuccessResponse', Message?: string | null } | null } | null };

export type GetClientFormDuPfaKeezDataQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  instance: Types.Scalars['String'];
}>;


export type GetClientFormDuPfaKeezDataQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getClientFormDuPfaKeezDataUsingGET?: { __typename?: 'accounts_DuPfaKeezFormRepresentation', data?: { __typename?: 'accounts_DuAnswersRepresentation', anRealizat?: number | null, anEstimat?: number | null, rectificativaRealizat?: boolean | null, rectificativaEstimat?: boolean | null, dreptAutorRealizat?: number | null, agriRealizat?: number | null, titluriValoareRealizat?: number | null, dividendeRealizat?: number | null, alteSurseRealizat?: number | null, dreptAutorEstimat?: number | null, agriEstimat?: number | null, titluriValoareEstimat?: number | null, dividendeEstimat?: number | null, alteSurseEstimat?: number | null, optionalSanatateRealizat?: boolean | null, optionalSanatateEstimat?: boolean | null, optionalPensieRealizat?: boolean | null, optionalPensieEstimat?: boolean | null, optiunePensieValoareEstimat?: number | null, venituriStrainatate?: number | null, cimNedeterminat?: string | null, impozitONG?: boolean | null, ongCIF?: string | null, ongIBAN?: string | null, comments?: string | null, persoana?: { __typename?: 'accounts_DuPersonRepresentation', nume?: string | null, prenume?: string | null, cnp?: string | null, adresa?: string | null, telefon?: string | null, email?: string | null, iban?: string | null, areHandicap?: boolean | null, nerezident?: boolean | null } | null, chiriiRealizat?: Array<{ __typename?: 'accounts_DuChirieRepresentation', sistemImpozitare?: string | null, adresa?: string | null, numarDocument?: number | null, dataDocument?: number | null, dataInceperiiActivitatii?: number | null, dataIncetariiActivitatii?: number | null, venitBrut?: number | null, cheltuieliDeductibile?: number | null }> | null, activitatiIndependenteRealizat?: Array<{ __typename?: 'accounts_DuActivitatiIndependenteRepresentation', sistemImpozitare?: string | null, formaOrganizare?: string | null, codCaen?: string | null, denCaen?: string | null, sediuSauIdentificareBun?: string | null, numarDocument?: number | null, dataDocument?: number | null, dataInceperiiActivitatii?: number | null, dataIncheieriiActivitatii?: number | null, venitBrut?: number | null, cheltuieliDeductibile?: number | null, normaDeVenit?: number | null }> | null, chiriiEstimat?: Array<{ __typename?: 'accounts_DuChirieRepresentation', sistemImpozitare?: string | null, adresa?: string | null, numarDocument?: number | null, dataDocument?: number | null, dataInceperiiActivitatii?: number | null, dataIncetariiActivitatii?: number | null, venitBrut?: number | null, cheltuieliDeductibile?: number | null }> | null, activitatiIndependenteEstimat?: Array<{ __typename?: 'accounts_DuActivitatiIndependenteRepresentation', sistemImpozitare?: string | null, formaOrganizare?: string | null, codCaen?: string | null, denCaen?: string | null, sediuSauIdentificareBun?: string | null, numarDocument?: number | null, dataDocument?: number | null, dataInceperiiActivitatii?: number | null, dataIncheieriiActivitatii?: number | null, venitBrut?: number | null, cheltuieliDeductibile?: number | null, normaDeVenit?: number | null }> | null } | null, formData?: { __typename?: 'accounts_ClientFormDataRepresentation', companyName?: string | null, display?: string | null, description?: string | null, displayRole?: string | null, status?: string | null, expires?: number | null, parameters?: any | null } | null } | null } | null };

export type GetCaenCodesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCaenCodesQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getCaenCodesUsingGET?: Array<{ __typename?: 'accounts_CaenCodeRepresentation', code?: string | null, description?: string | null, industry?: string | null }> | null } | null };

export type GetFormComponentsQueryVariables = Types.Exact<{
  formCode?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetFormComponentsQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getFormComponentsUsingGET?: Array<{ __typename?: 'accounts_FormComponentRepresentation', formComponentId?: number | null, formCode?: string | null, componentCode?: string | null, data?: string | null }> | null } | null };

export type GetActiveFormCountQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  filter?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetActiveFormCountQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getActiveFormCountUsingGET?: { __typename?: 'accounts_ClientFormCountRepresentation', count?: number | null } | null } | null };

export type UpdateClientFormDuPfaKeezDataMutationVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  instance: Types.Scalars['String'];
  doSubmit: Types.Scalars['Boolean'];
  data: Types.Accounts_DuAnswersRepresentationInput;
}>;


export type UpdateClientFormDuPfaKeezDataMutation = { __typename?: 'Mutation', accounts?: { __typename?: 'accounts_mutation', updateClientFormDuPfaKeezDataUsingPUT?: { __typename?: 'accounts_SuccessResponse', Message?: string | null } | null } | null };

export type InvalidateClientFormMutationVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  body: Types.Accounts_ClientFormSpecRepresentationInput;
}>;


export type InvalidateClientFormMutation = { __typename?: 'Mutation', accounts?: { __typename?: 'accounts_mutation', invalidateClientFormUsingPUT?: { __typename?: 'accounts_SuccessResponse', Message?: string | null } | null } | null };

export type GetClientFormsDataQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  filter?: Types.InputMaybe<Types.Scalars['String']>;
  order?: Types.InputMaybe<Types.Scalars['String']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  count?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetClientFormsDataQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getClientFormsDataUsingGET?: { __typename?: 'accounts_ClientFormViewRepresentation', recordsCount?: number | null, first?: number | null, last?: number | null, pageSize?: number | null, data?: Array<{ __typename?: 'accounts_ClientFormRepresentation', clientEid?: string | null, clientName?: string | null, fiscalNumber?: string | null, formStatus?: string | null, answeredByUserEid?: string | null, answeredByUserName?: string | null, answeredDateTime?: string | null, createdByUserEid?: string | null, createdByUserName?: string | null, createdDateTime?: string | null, form?: { __typename?: 'accounts_FormRepresenation', externalId?: string | null, display?: string | null, description?: string | null, instanceParameters?: any | null, formType?: { __typename?: 'accounts_FormTypeRepresentation', externalId?: string | null, display?: string | null, description?: string | null, displayForRole?: string | null, notificationChatTypeEid?: string | null } | null } | null }> | null } | null } | null };

export type GetClientFiscalInfoSummaryForMonthQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  forMonth: Types.Scalars['Int'];
}>;


export type GetClientFiscalInfoSummaryForMonthQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getClientFiscalInfoSummaryForMonthUsingGET?: { __typename?: 'accounts_ClientFiscalInfoSummaryRepresentation', profitMicroCode?: string | null } | null } | null };

export type GetClientFormDuPfaKeez2024DataQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
}>;


export type GetClientFormDuPfaKeez2024DataQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getClientFormDuPfaKeez2024DataUsingGET?: { __typename?: 'accounts_DuPfaKeez2024FormRepresentation', data?: { __typename?: 'accounts_DuAnswers2024Representation', anRealizat?: number | null, rectificativaRealizat?: boolean | null, dreptAutorRealizat?: number | null, agriRealizat?: number | null, dividendeRealizat?: number | null, alteSurseRealizat?: number | null, venituriStrainatate?: number | null, cimNedeterminat?: string | null, comments?: string | null, persoana?: { __typename?: 'accounts_DuPersonRepresentation', nume?: string | null, prenume?: string | null, cnp?: string | null, adresa?: string | null, telefon?: string | null, email?: string | null, iban?: string | null, areHandicap?: boolean | null, nerezident?: boolean | null } | null, chiriiRealizat?: Array<{ __typename?: 'accounts_DuChirieRepresentation', sistemImpozitare?: string | null, adresa?: string | null, numarDocument?: number | null, dataDocument?: number | null, dataInceperiiActivitatii?: number | null, dataIncetariiActivitatii?: number | null, venitBrut?: number | null, cheltuieliDeductibile?: number | null }> | null, activitatiIndependenteRealizat?: Array<{ __typename?: 'accounts_DuActivitatiIndependenteRepresentation', sistemImpozitare?: string | null, formaOrganizare?: string | null, codCaen?: string | null, denCaen?: string | null, sediuSauIdentificareBun?: string | null, numarDocument?: number | null, dataDocument?: number | null, dataInceperiiActivitatii?: number | null, dataIncheieriiActivitatii?: number | null, venitBrut?: number | null, cheltuieliDeductibile?: number | null, normaDeVenit?: number | null }> | null, estimatCASS?: { __typename?: 'accounts_DuAnswers2024EstimatCASSRepresentation', bifaCASS?: boolean | null, optiuneCASS?: string | null } | null } | null, formData?: { __typename?: 'accounts_ClientFormDataRepresentation', companyName?: string | null, display?: string | null, description?: string | null, displayRole?: string | null, status?: string | null, expires?: number | null, parameters?: any | null } | null } | null } | null };

export type UpdateClientFormDuPfaKeez2024DataMutationVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  doSubmit: Types.Scalars['Boolean'];
  data: Types.Accounts_DuAnswers2024RepresentationInput;
}>;


export type UpdateClientFormDuPfaKeez2024DataMutation = { __typename?: 'Mutation', accounts?: { __typename?: 'accounts_mutation', updateClientFormDuPfaKeez2024DataUsingPUT?: { __typename?: 'accounts_SuccessResponse', Message?: string | null } | null } | null };

export type GetClientFormDuPfaKeez2025DataQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
}>;


export type GetClientFormDuPfaKeez2025DataQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getClientFormDuPfaKeez2025DataUsingGET?: { __typename?: 'accounts_DuPfaKeez2025FormRepresentation', data?: { __typename?: 'accounts_DuAnswers2025Representation', anRealizat?: number | null, lunaR?: number | null, rectificativaRealizat?: boolean | null, totalPlataA?: number | null, bifa18?: number | null, bifa111?: number | null, bifa112?: number | null, bifa14?: number | null, bifa131?: number | null, bifa132?: number | null, dreptAutorRealizat?: number | null, agriRealizat?: number | null, titluriValoareRealizat?: number | null, dividendeRealizat?: number | null, alteSurseRealizat?: number | null, optionalSanatateRealizat?: boolean | null, optionalPensieRealizat?: boolean | null, venituriStrainatate?: number | null, cimNedeterminat?: string | null, impozitONG?: boolean | null, ongCIF?: string | null, ongIBAN?: string | null, ongName?: string | null, comments?: string | null, persoana?: { __typename?: 'accounts_DuPerson2025Representation', nume?: string | null, prenume?: string | null, initiala?: string | null, cnp?: string | null, adresa?: string | null, telefon?: string | null, email?: string | null, iban?: string | null, areHandicap?: boolean | null, nerezident?: boolean | null, statut?: number | null } | null, chiriiRealizat?: Array<{ __typename?: 'accounts_DuChirieRepresentation', sistemImpozitare?: string | null, adresa?: string | null, numarDocument?: number | null, dataDocument?: number | null, dataInceperiiActivitatii?: number | null, dataIncetariiActivitatii?: number | null, venitBrut?: number | null, cheltuieliDeductibile?: number | null }> | null, activitatiIndependenteRealizat?: Array<{ __typename?: 'accounts_DuActivitatiIndependente2025Representation', sistemImpozitare?: string | null, formaOrganizare?: string | null, codCaen?: string | null, denCaen?: string | null, sediuSauIdentificareBun?: string | null, numarDocument?: string | null, dataDocument?: number | null, dataInceperiiActivitatii?: number | null, dataIncheieriiActivitatii?: number | null, venitBrut?: number | null, cheltuieliDeductibile?: number | null, normaDeVenit?: number | null, categVenit?: number | null, denVenit?: string | null, detVenNet?: number | null, pierderePrecedenta?: number | null, pierdereCompensata?: number | null, venitRecalculat?: number | null, impozitRetinut?: number | null }> | null, obligRealizat?: { __typename?: 'accounts_DuObligRealizat2025Representation', cassTotalVenAi?: number | null, bazaCassDatoratAi?: number | null, cassAnualaAi?: number | null, cassDatoratArt180Ai?: number | null, cassDatoratAi?: number | null, cassRetinutPlatitorAlin6Ai?: number | null, cassDifPlusAi?: number | null, bifaCassDatoratAi?: number | null, oblimpozRealTotal?: number | null, oblimpozRealAnticipat?: number | null, oblimpozRealDifRestituit?: number | null, oblcasRealDifPlus?: number | null, oblcassRealDifPlusAi?: number | null, impozitVenitMinus?: number | null, casPlus?: number | null, cassPlus?: number | null, difDePlata?: number | null } | null, coasigurati?: Array<{ __typename?: 'accounts_DuCoasigurat2025Representation', tipCoasigurat?: number | null, bazaCassCoasigurat?: number | null, cassDatoratCoasigurat?: number | null }> | null } | null, formData?: { __typename?: 'accounts_ClientFormDataRepresentation', companyName?: string | null, display?: string | null, description?: string | null, displayRole?: string | null, status?: string | null, expires?: number | null, parameters?: any | null } | null } | null } | null };

export type UpdateClientFormDuPfaKeez2025DataMutationVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  doSubmit: Types.Scalars['Boolean'];
  data: Types.Accounts_DuAnswers2025RepresentationInput;
}>;


export type UpdateClientFormDuPfaKeez2025DataMutation = { __typename?: 'Mutation', accounts?: { __typename?: 'accounts_mutation', updateClientFormDuPfaKeez2025DataUsingPUT?: { __typename?: 'accounts_SuccessResponse', Message?: string | null } | null } | null };

export const GetClientFormMicroProfitDataDocument = gql`
    query getClientFormMicroProfitData($clientEid: String!, $instance: String!) {
  accounts {
    getClientFormMicroProfitDataUsingGET(clientEid: $clientEid, instance: $instance) {
      data {
        are1FTE
        areConsultanta80
        are253Micro
        pastreazaFirmaMicro
        ramaneMicro
        doresteMicro
        devineMicro
        ramaneProfit
        devineProfit
        micro1p
        micro3p
        caSub500k
        defaultAre1FTE
        defaultAreConsultanta80
        defaultAre253Micro
      }
      formData {
        companyName
        display
        description
        displayRole
        status
        expires
        parameters
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetClientFormMicroProfitDataGQL extends Apollo.Query<GetClientFormMicroProfitDataQuery, GetClientFormMicroProfitDataQueryVariables> {
    document = GetClientFormMicroProfitDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClientFormMicroProfitDataDocument = gql`
    mutation updateClientFormMicroProfitData($clientEid: String!, $instance: String!, $data: accounts_MicroProfitAnswersRepresentationInput!) {
  accounts {
    updateClientFormMicroProfitDataUsingPUT(clientEid: $clientEid, instance: $instance, data: $data) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClientFormMicroProfitDataGQL extends Apollo.Mutation<UpdateClientFormMicroProfitDataMutation, UpdateClientFormMicroProfitDataMutationVariables> {
    document = UpdateClientFormMicroProfitDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetClientFormDuPfaKeezDataDocument = gql`
    query getClientFormDuPfaKeezData($clientEid: String!, $instance: String!) {
  accounts {
    getClientFormDuPfaKeezDataUsingGET(clientEid: $clientEid, instance: $instance) {
      data {
        persoana {
          nume
          prenume
          cnp
          adresa
          telefon
          email
          iban
          areHandicap
          nerezident
        }
        anRealizat
        anEstimat
        rectificativaRealizat
        rectificativaEstimat
        chiriiRealizat {
          sistemImpozitare
          adresa
          numarDocument
          dataDocument
          dataInceperiiActivitatii
          dataIncetariiActivitatii
          venitBrut
          cheltuieliDeductibile
        }
        activitatiIndependenteRealizat {
          sistemImpozitare
          formaOrganizare
          codCaen
          denCaen
          sediuSauIdentificareBun
          numarDocument
          dataDocument
          dataInceperiiActivitatii
          dataIncheieriiActivitatii
          venitBrut
          cheltuieliDeductibile
          normaDeVenit
        }
        dreptAutorRealizat
        agriRealizat
        titluriValoareRealizat
        dividendeRealizat
        alteSurseRealizat
        chiriiEstimat {
          sistemImpozitare
          adresa
          numarDocument
          dataDocument
          dataInceperiiActivitatii
          dataIncetariiActivitatii
          venitBrut
          cheltuieliDeductibile
        }
        activitatiIndependenteEstimat {
          sistemImpozitare
          formaOrganizare
          codCaen
          denCaen
          sediuSauIdentificareBun
          numarDocument
          dataDocument
          dataInceperiiActivitatii
          dataIncheieriiActivitatii
          venitBrut
          cheltuieliDeductibile
          normaDeVenit
        }
        dreptAutorEstimat
        agriEstimat
        titluriValoareEstimat
        dividendeEstimat
        alteSurseEstimat
        optionalSanatateRealizat
        optionalSanatateEstimat
        optionalPensieRealizat
        optionalPensieEstimat
        optiunePensieValoareEstimat
        venituriStrainatate
        cimNedeterminat
        impozitONG
        ongCIF
        ongIBAN
        comments
      }
      formData {
        companyName
        display
        description
        displayRole
        status
        expires
        parameters
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetClientFormDuPfaKeezDataGQL extends Apollo.Query<GetClientFormDuPfaKeezDataQuery, GetClientFormDuPfaKeezDataQueryVariables> {
    document = GetClientFormDuPfaKeezDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCaenCodesDocument = gql`
    query getCaenCodes {
  accounts {
    getCaenCodesUsingGET {
      code
      description
      industry
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCaenCodesGQL extends Apollo.Query<GetCaenCodesQuery, GetCaenCodesQueryVariables> {
    document = GetCaenCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFormComponentsDocument = gql`
    query getFormComponents($formCode: String) {
  accounts {
    getFormComponentsUsingGET(formCode: $formCode) {
      formComponentId
      formCode
      componentCode
      data
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFormComponentsGQL extends Apollo.Query<GetFormComponentsQuery, GetFormComponentsQueryVariables> {
    document = GetFormComponentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActiveFormCountDocument = gql`
    query getActiveFormCount($clientEid: String!, $filter: String) {
  accounts {
    getActiveFormCountUsingGET(clientEid: $clientEid, filter: $filter) {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActiveFormCountGQL extends Apollo.Query<GetActiveFormCountQuery, GetActiveFormCountQueryVariables> {
    document = GetActiveFormCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClientFormDuPfaKeezDataDocument = gql`
    mutation updateClientFormDuPfaKeezData($clientEid: String!, $instance: String!, $doSubmit: Boolean!, $data: accounts_DuAnswersRepresentationInput!) {
  accounts {
    updateClientFormDuPfaKeezDataUsingPUT(clientEid: $clientEid, instance: $instance, doSubmit: $doSubmit, data: $data) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClientFormDuPfaKeezDataGQL extends Apollo.Mutation<UpdateClientFormDuPfaKeezDataMutation, UpdateClientFormDuPfaKeezDataMutationVariables> {
    document = UpdateClientFormDuPfaKeezDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvalidateClientFormDocument = gql`
    mutation invalidateClientForm($clientEid: String!, $body: accounts_ClientFormSpecRepresentationInput!) {
  accounts {
    invalidateClientFormUsingPUT(clientEid: $clientEid, body: $body) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvalidateClientFormGQL extends Apollo.Mutation<InvalidateClientFormMutation, InvalidateClientFormMutationVariables> {
    document = InvalidateClientFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetClientFormsDataDocument = gql`
    query getClientFormsData($clientEid: String!, $filter: String, $order: String, $offset: Int, $count: Int) {
  accounts {
    getClientFormsDataUsingGET(clientEid: $clientEid, filter: $filter, order: $order, offset: $offset, count: $count) {
      recordsCount
      first
      last
      pageSize
      data {
        clientEid
        clientName
        fiscalNumber
        form {
          externalId
          display
          description
          formType {
            externalId
            display
            description
            displayForRole
            notificationChatTypeEid
          }
          instanceParameters
        }
        formStatus
        answeredByUserEid
        answeredByUserName
        answeredDateTime
        createdByUserEid
        createdByUserName
        createdDateTime
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetClientFormsDataGQL extends Apollo.Query<GetClientFormsDataQuery, GetClientFormsDataQueryVariables> {
    document = GetClientFormsDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetClientFiscalInfoSummaryForMonthDocument = gql`
    query getClientFiscalInfoSummaryForMonth($clientEid: String!, $forMonth: Int!) {
  accounts {
    getClientFiscalInfoSummaryForMonthUsingGET(clientEid: $clientEid, forMonth: $forMonth) {
      profitMicroCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetClientFiscalInfoSummaryForMonthGQL extends Apollo.Query<GetClientFiscalInfoSummaryForMonthQuery, GetClientFiscalInfoSummaryForMonthQueryVariables> {
    document = GetClientFiscalInfoSummaryForMonthDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetClientFormDuPfaKeez2024DataDocument = gql`
    query getClientFormDuPfaKeez2024Data($clientEid: String!) {
  accounts {
    getClientFormDuPfaKeez2024DataUsingGET(clientEid: $clientEid) {
      data {
        persoana {
          nume
          prenume
          cnp
          adresa
          telefon
          email
          iban
          areHandicap
          nerezident
        }
        anRealizat
        rectificativaRealizat
        chiriiRealizat {
          sistemImpozitare
          adresa
          numarDocument
          dataDocument
          dataInceperiiActivitatii
          dataIncetariiActivitatii
          venitBrut
          cheltuieliDeductibile
        }
        activitatiIndependenteRealizat {
          sistemImpozitare
          formaOrganizare
          codCaen
          denCaen
          sediuSauIdentificareBun
          numarDocument
          dataDocument
          dataInceperiiActivitatii
          dataIncheieriiActivitatii
          venitBrut
          cheltuieliDeductibile
          normaDeVenit
        }
        dreptAutorRealizat
        agriRealizat
        dividendeRealizat
        alteSurseRealizat
        venituriStrainatate
        cimNedeterminat
        comments
        estimatCASS {
          bifaCASS
          optiuneCASS
        }
      }
      formData {
        companyName
        display
        description
        displayRole
        status
        expires
        parameters
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetClientFormDuPfaKeez2024DataGQL extends Apollo.Query<GetClientFormDuPfaKeez2024DataQuery, GetClientFormDuPfaKeez2024DataQueryVariables> {
    document = GetClientFormDuPfaKeez2024DataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClientFormDuPfaKeez2024DataDocument = gql`
    mutation updateClientFormDuPfaKeez2024Data($clientEid: String!, $doSubmit: Boolean!, $data: accounts_DuAnswers2024RepresentationInput!) {
  accounts {
    updateClientFormDuPfaKeez2024DataUsingPUT(clientEid: $clientEid, doSubmit: $doSubmit, data: $data) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClientFormDuPfaKeez2024DataGQL extends Apollo.Mutation<UpdateClientFormDuPfaKeez2024DataMutation, UpdateClientFormDuPfaKeez2024DataMutationVariables> {
    document = UpdateClientFormDuPfaKeez2024DataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetClientFormDuPfaKeez2025DataDocument = gql`
    query getClientFormDuPfaKeez2025Data($clientEid: String!) {
  accounts {
    getClientFormDuPfaKeez2025DataUsingGET(clientEid: $clientEid) {
      data {
        persoana {
          nume
          prenume
          initiala
          cnp
          adresa
          telefon
          email
          iban
          areHandicap
          nerezident
          statut
        }
        anRealizat
        lunaR
        rectificativaRealizat
        totalPlataA
        bifa18
        bifa111
        bifa112
        bifa14
        bifa131
        bifa132
        chiriiRealizat {
          sistemImpozitare
          adresa
          numarDocument
          dataDocument
          dataInceperiiActivitatii
          dataIncetariiActivitatii
          venitBrut
          cheltuieliDeductibile
        }
        activitatiIndependenteRealizat {
          sistemImpozitare
          formaOrganizare
          codCaen
          denCaen
          sediuSauIdentificareBun
          numarDocument
          dataDocument
          dataInceperiiActivitatii
          dataIncheieriiActivitatii
          venitBrut
          cheltuieliDeductibile
          normaDeVenit
          categVenit
          denVenit
          detVenNet
          pierderePrecedenta
          pierdereCompensata
          venitRecalculat
          impozitRetinut
        }
        dreptAutorRealizat
        agriRealizat
        titluriValoareRealizat
        dividendeRealizat
        alteSurseRealizat
        optionalSanatateRealizat
        optionalPensieRealizat
        venituriStrainatate
        cimNedeterminat
        impozitONG
        ongCIF
        ongIBAN
        ongName
        comments
        obligRealizat {
          cassTotalVenAi
          bazaCassDatoratAi
          cassAnualaAi
          cassDatoratArt180Ai
          cassDatoratAi
          cassRetinutPlatitorAlin6Ai
          cassDifPlusAi
          bifaCassDatoratAi
          oblimpozRealTotal
          oblimpozRealAnticipat
          oblimpozRealDifRestituit
          oblcasRealDifPlus
          oblcassRealDifPlusAi
          impozitVenitMinus
          casPlus
          cassPlus
          difDePlata
        }
        coasigurati {
          tipCoasigurat
          bazaCassCoasigurat
          cassDatoratCoasigurat
        }
      }
      formData {
        companyName
        display
        description
        displayRole
        status
        expires
        parameters
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetClientFormDuPfaKeez2025DataGQL extends Apollo.Query<GetClientFormDuPfaKeez2025DataQuery, GetClientFormDuPfaKeez2025DataQueryVariables> {
    document = GetClientFormDuPfaKeez2025DataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClientFormDuPfaKeez2025DataDocument = gql`
    mutation updateClientFormDuPfaKeez2025Data($clientEid: String!, $doSubmit: Boolean!, $data: accounts_DuAnswers2025RepresentationInput!) {
  accounts {
    updateClientFormDuPfaKeez2025DataUsingPUT(clientEid: $clientEid, doSubmit: $doSubmit, data: $data) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClientFormDuPfaKeez2025DataGQL extends Apollo.Mutation<UpdateClientFormDuPfaKeez2025DataMutation, UpdateClientFormDuPfaKeez2025DataMutationVariables> {
    document = UpdateClientFormDuPfaKeez2025DataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }